import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';

/** Government application: Cognocracy's connection to NCDS and the Government workspace demo. */
export function CognocracyGovernment() {
  return <section id="government-application" aria-labelledby="cognocracy-government" className="scroll-mt-20 bg-navy text-white py-20 lg:py-28" data-id="element-253" data-mp="2s6r5dr5kgngo">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end" data-id="element-254" data-mp="24hg3g6chcn0y">
        <div className="lg:col-span-7" data-id="element-255" data-mp="2e79gzcw6nc7u">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-256" data-mp="2e92mgov27qe9">Government application</p>
          <h2 id="cognocracy-government" className="font-heading font-bold text-3xl lg:text-4xl tracking-tight leading-tight" data-id="element-257" data-mp="29eopii0r1b7h">
            From civic framework to coordinated public services.
          </h2>
          <p className="mt-5 text-lg text-white/80 leading-relaxed" data-id="element-258" data-mp="38bcmzixyu71h">
            The National Capability and Development System (NCDS) is the government solution associated with
            Cognocracy. It brings citizen development, applications, referrals and service coordination into Noetivra’s
            shared infrastructure, with a Citizen Workspace and an Administration Control Panel you can explore in the
            Government demo.
          </p>
        </div>
        <div className="lg:col-span-5 lg:justify-self-end" data-id="element-259" data-mp="2pebhlx0i24x0">
          <a href="/government" className="inline-flex items-center justify-center gap-2 bg-white text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-260" data-mp="2uccxk92mpo49">
            See the Government solution <ArrowRight size={18} aria-hidden="true" data-id="element-261" data-mp="ikzioooomcgo" />
          </a>
        </div>
      </motion.div>
    </section>;
}